import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  FieldType,
  TemplateFieldV2,
} from "../../../../docuclipper/DocuclipperTypes";
import {
  fetchExtractedData,
  setNumColumns,
  updateColumnFieldType,
  updateColumnName,
  updateColumnWidth,
  updateNumHeaderRows,
} from "../../../../redux/reducers/TemplateField";
import { ColumnConfig } from "./ColumnConfig";
import { QboConfig } from "./QboConfig";
import { VerticalMerge } from "./VerticalMerge";
import { withSelectedField } from "./withSelectedField";

type Props = {
  field: TemplateFieldV2;
};

export const TableConfigSelector2: React.SFC<Props> = ({ field }) => {
  const dispatch = useDispatch();

  if (field.toolType !== "ocrtables") {
    return null;
  }
  const columns = field.tableConfig.columns.length;

  return (
    <>
      <Row>
        <Col xs={6}>
          {/* <div className="h5">Columns</div> */}
          <Form.Label>
            <strong>Columns</strong>
          </Form.Label>
          <Form.Control
            type="number"
            name="numColumns"
            placeholder="Number of columns"
            value={columns}
            onChange={(e) => {
              dispatch(
                setNumColumns({
                  id: field.id,
                  numColumns: parseInt(e.target.value, 10),
                })
              );
              dispatch(fetchExtractedData({ id: field.id }));
            }}
          />
        </Col>
        <Col xs={6}>
          {/* <div className="h5">Heading rows</div> */}
          <Form.Label>
            <strong>Header rows</strong>
          </Form.Label>
          <Form.Control
            type="number"
            value={field.tableConfig.headerRows}
            onChange={(e) =>
              dispatch(
                updateNumHeaderRows({
                  id: field.id,
                  headerRows: Math.max(0, parseInt(e.target.value, 10)),
                })
              )
            }
          />
        </Col>
      </Row>
      {columns > 0 && (
        <>
          {/* <Row>
            <Col>Name</Col>
            <Col>Field type</Col>
          </Row> */}
          {field.tableConfig.columns.map((c, i) => (
            <div className="my-2">
              <ColumnConfig
                placeholder={`Column ${i + 1} name`}
                key={i}
                column={c}
                onFieldTypeChange={(fieldType: FieldType) => {
                  dispatch(
                    updateColumnFieldType({
                      columnIndex: i,
                      id: field.id,
                      fieldType,
                    })
                  );
                  dispatch(fetchExtractedData({ id: field.id }));
                }}
                onWidthChange={(width: number) => {
                  dispatch(
                    updateColumnWidth({
                      columnIndex: i,
                      id: field.id,
                      percentage: width,
                    })
                  );
                  dispatch(fetchExtractedData({ id: field.id }));
                }}
                onNameChange={(name: string) =>
                  dispatch(
                    updateColumnName({
                      columnIndex: i,
                      id: field.id,
                      name,
                    })
                  )
                }
              />
              <hr />
            </div>
          ))}
          <div className="mt-2">
            <QboConfig />
          </div>
          <div className="mt-4">
            <VerticalMerge />
          </div>
        </>
      )}
    </>
  );
};

export const TableConfigSelector = withSelectedField(TableConfigSelector2);
